"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = completeLeadSurvey;
async function completeLeadSurvey({ leadSurveyId, groupId }) {
    const response = await fetch(`/api/surveys/leads/${leadSurveyId}/groups/${groupId}/complete`, {
        method: 'GET'
    });
    return response.json();
}
//# sourceMappingURL=completeLeadSurvey.js.map